import * as React from 'react';
import { Box, Typography } from '@mui/material';
import Fluid from 'components/Fluid'
import { Autoplay, EffectFade, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';

const TextSlider = ({slides, title, flush, background, backgroundImage, backgroundProps, padding, ...props}) => {

	const paginationRef = React.useRef(null);
	const swiperRef = React.useRef(null);
	const [swiperKey, setSwiperKey] = React.useState(0);

	React.useEffect(() => {
		if (paginationRef?.current) {
			setSwiperKey(s => s + 1);
		}
	}, [slides, paginationRef]);

	const sectionInlineStyle = {
		...(backgroundImage ? {
			backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage}?max-w=1920&format=webp)`,
			...(backgroundProps ? {
				...(backgroundProps.indexOf('cover') !== -1 ? {
					backgroundSize: 'cover',
				} : null),
				...(backgroundProps.indexOf('fixed') !== -1 ? {
					backgroundAttachment: 'fixed',
				} : null),
				...(backgroundProps.indexOf('repeat') !== -1 ? {
					backgroundRepeat: 'repeat',
				} : {backgroundRepeat: 'no-repeat'}),
			} : null),
		} : null),
	}

	if (!slides || slides?.length === 0) return null;

	return (
		<Box sx={(Object.keys(sectionInlineStyle).length > 0 ? sectionInlineStyle : null)}
			className={[
				'textSlider__section', 
				(padding ? 'padding-normal' : ''), 
				(flush ? 'margin-flush' : ''),
				(background||'')
			].join(' ')}
		>
			{title && <Fluid layout={{md:'8', lg:'7'}} justifyContent="center">
				<Typography component="div" variant="h2" className="textSlider__title">{title}</Typography>
			</Fluid>}
			{slides && slides?.length && <Fluid layout={{md:'8'}} justifyContent="center">
				<Swiper
					modules={[Autoplay, Pagination, EffectFade]}
					slidesPerView={1}
					slidesPerGroup={1}
					pagination={{
						clickable: true,
						type: 'bullets',
						bulletClass: 'textSlider__bullet',
						bulletActiveClass: 'textSlider__bullet-active',
						bulletElement: 'button',
						modifierClass: 'textSlider__',
						el: paginationRef?.current,
						renderBullet: function (index, className) {
							return '<button aria-label="Text Slide ' + (index + 1) + '" class="' + className + '"></button>';
						},
					}}
					className={'textSlider'}
					effect={'fade'}
					fadeEffect={{
						crossFade:true
					}}
					centeredSlides={false}
					spaceBetween={'0'}
					speed={1000}
					loop={true}
					// autoplay={false}
					autoplay={{
						delay: 3000,
		      			pauseOnMouseEnter: true,
		      		}}
		      		key={swiperKey}
					onBeforeInit={(swiper) => {
						swiperRef.current = swiper;
					}}
		      	>
		      			{slides && slides.length > 0 && slides.map((slide,index) => {
						return (
							<SwiperSlide key={index} className="textSlider__slide">
								<div className="textSlider__inner">
									{slide?.title && <Typography className="textSlider__slide_title" component="div" variant="h3">{slide?.title}</Typography>}
									{slide?.description && <Typography className="textSlider__slide_description" component="div" variant="large">{slide?.description}</Typography>}
								</div>
							</SwiperSlide>
						)
					})}
		      	</Swiper>
		      	<Fluid layout={{xs:'12',ms:'8',lg:'4'}} justifyContent={'center'} className="textSlider__pagination">
					<div ref={paginationRef} />
				</Fluid>
			</Fluid>}
		</Box>
	)
}

export default React.memo(TextSlider);